import { render, staticRenderFns } from "./WxappSetting.vue?vue&type=template&id=359f9872&scoped=true"
import script from "./WxappSetting.vue?vue&type=script&lang=js"
export * from "./WxappSetting.vue?vue&type=script&lang=js"
import style0 from "./WxappSetting.vue?vue&type=style&index=0&id=359f9872&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359f9872",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359f9872')) {
      api.createRecord('359f9872', component.options)
    } else {
      api.reload('359f9872', component.options)
    }
    module.hot.accept("./WxappSetting.vue?vue&type=template&id=359f9872&scoped=true", function () {
      api.rerender('359f9872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/store/WxappSetting.vue"
export default component.exports